import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IAcademicGroups } from "./routeType";
import { useGetAcademicGroup } from "./get";
import { useGetAllAcademicGroup } from "./getAll";

const { getPath } = getApi("academicGroups.put");

type IExtractedRouteType = IAcademicGroups["academicGroupSingleUpdate"];

export type IPutAcademicGroup = IPickMutation<IExtractedRouteType>;

const putAcademicGroup: MutationFunction<
  IPutAcademicGroup["response"],
  IPutAcademicGroup["variables"]
> = ({ academicGroupId, ...data }) => {
  return axiosClient.put(getPath({ academicGroupId }), data);
};

export const usePutAcademicGroup = createMutation({
  mutationFn: putAcademicGroup,
  onSuccess: (_, { academicGroupId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAcademicGroup.getKey({ academicGroupId }),
    });
    queryClient.invalidateQueries({
      queryKey: useGetAllAcademicGroup.getKey(),
    });
  },
});
